import React from "react";
import PropTypes from "prop-types";
import ProgressMilestones from "./ProgressMilestones";
import CustomButton from "../CustomButton";

const NetworkGrowthSummary = ({
  stats,
  onImportMore,
  onInviteMore,
  onOptOut,
}) => {
  if (!stats) return null;

  const imported = stats.imported || 0;
  const invitesSent = stats.invites_sent || 0;
  const showNextStep = imported > 0 && invitesSent === 0;

  return (
    <div className="grow-network-summary">
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
        <h4>Network Growth</h4>
        <div className="d-flex flex-wrap gn-summary-actions">
          <CustomButton
            text="Import More"
            backgroundColor="#fff"
            color="#3A6ED4"
            borderColor="#3A6ED4"
            handleClick={onImportMore}
            additionalClass="mr-2 mb-2"
          />
          <CustomButton
            text="Invite Contacts"
            backgroundColor="#3A6ED4"
            color="#fff"
            handleClick={onInviteMore}
            additionalClass="mb-2"
          />
        </div>
      </div>
      {showNextStep && (
        <div className="gn-next-step">
          <div>
            <strong>Next step:</strong> Invite your contacts so they can join
            Workbrook. Nothing is sent until you choose who to invite.
          </div>
          <CustomButton
            text="Invite Contacts"
            backgroundColor="#3A6ED4"
            color="#fff"
            handleClick={onInviteMore}
            additionalClass="gn-next-step-btn"
          />
        </div>
      )}
      <div className="gn-stats-row">
        <div className="gn-stat">
          <div className="gn-stat-value">{imported}</div>
          <div className="gn-stat-label">Contacts imported</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{invitesSent}</div>
          <div className="gn-stat-label">Invites sent</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.converted || 0}</div>
          <div className="gn-stat-label">Successful signups</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.pending || 0}</div>
          <div className="gn-stat-label">Pending</div>
        </div>
      </div>
      <ProgressMilestones
        milestones={stats.milestones || []}
        currentMilestone={stats.current_milestone || 0}
        campaignActive={!!stats.campaign_active}
      />
      {imported > 0 && onOptOut && (
        <div className="gn-opt-out">
          <button type="button" className="gn-opt-out-btn" onClick={onOptOut}>
            Opt out & delete all contacts
          </button>
        </div>
      )}
    </div>
  );
};

NetworkGrowthSummary.propTypes = {
  stats: PropTypes.object,
  onImportMore: PropTypes.func,
  onInviteMore: PropTypes.func,
  onOptOut: PropTypes.func,
};

export default NetworkGrowthSummary;
